import { queryClient } from "@/queryClient"
import api from "@/services/api"
import { BASE_ORDERS_QUERY_KEY } from "../queryKeys"
import type { CreateTransactionResponseInvoice } from "@/services/createTransaction"

type ForcePayInvoiceResponse = {
  totalPaid: number
  invoice: CreateTransactionResponseInvoice
}

export const forcePayInvoice = async (
  invoiceId: string
) => {
  const response = await api.post<ForcePayInvoiceResponse>(
    `/invoices/${invoiceId}/force-pay/`
  )

  queryClient.invalidateQueries({
    queryKey: [BASE_ORDERS_QUERY_KEY],
  })

  return response.body
}
